/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import TIMES from 'cio/utils/times';
import TIME_ZONES, { CUSTOMER_TIME_ZONE, CAMPAIGN_TIME_ZONES } from 'cio/utils/time-zones';

interface CioTimePickerSignature {
  Args: {
    startTime?: string;
    endTime?: string;
    time?: string;
    timeZone?: string;
    fallbackTimeZone?: string;
    hideLabel?: boolean;
    hideZone?: boolean;
    canSelectUserTimeZone?: boolean;
    canSelectFallbackTimezone?: boolean;
    useRange?: boolean;
    endTimesThreshold?: number;
    dropdownSmall?: boolean;
    disabled?: boolean;
    onTimeChange?: (time: string) => unknown;
    onTimeZoneChange?: (timeZone: string) => unknown;
    onFallbackTimezoneChange?: (timeZone: string) => unknown;
    onStartTimeChange?: (startTime: string) => unknown;
    onEndTimeChange?: (endTime: string) => unknown;
  };
  Element: HTMLDivElement;
}

export default class CioTimePicker extends Component<CioTimePickerSignature> {
  @tracked timeZone = this.args.timeZone ?? '';
  @tracked fallbackTimeZone = this.args.fallbackTimeZone ?? '';

  readonly times = TIMES;
  readonly fallbackTimeZones = TIME_ZONES;

  get endTimesThreshold() {
    return this.args.endTimesThreshold ?? 1;
  }

  get startTimes() {
    return TIMES.slice(0, this.endTimesThreshold * -1);
  }

  get endTimes() {
    let times = TIMES.slice();

    if (this.args.startTime == null) {
      return times.slice(this.endTimesThreshold);
    }

    let index = times.findIndex((time) => time.value === this.args.startTime);

    return times.slice(index + this.endTimesThreshold);
  }

  get timeZones() {
    return this.args.canSelectUserTimeZone === true ? CAMPAIGN_TIME_ZONES : TIME_ZONES;
  }

  get hasSelectedCustomerTimezone() {
    return this.args.timeZone === CUSTOMER_TIME_ZONE.value;
  }

  @action
  timeChanged(value: string) {
    this.args.onTimeChange?.(value);
  }

  @action
  timeZoneChanged(value: string) {
    this.args.onTimeZoneChange?.(value);
  }

  @action
  fallbackTimeZoneChanged(value: string) {
    this.args.onFallbackTimezoneChange?.(value);
  }

  @action
  startTimeChanged(startTimeValue: string) {
    this.args.onStartTimeChange?.(startTimeValue);

    if (!this.endTimes.some((t) => t.value === this.args.endTime)) {
      this.args.onEndTimeChange?.(this.endTimes[0].value);
    }
  }

  @action
  endTimeChanged(endTimeValue: string) {
    this.args.onEndTimeChange?.(endTimeValue);
  }
}
